import React from 'react';
import { Check, Circle, Clock } from 'lucide-react';
interface TransactionStep {
  id: string;
  label: string;
  status: 'completed' | 'current' | 'pending';
  date?: string;
}
interface TransactionTrackerProps {
  steps: TransactionStep[];
}
export function TransactionTracker({
  steps
}: TransactionTrackerProps) {
  return <div className="bg-white border border-gray-300 p-6" data-id="element-1134">
      <h3 className="font-bold text-lg mb-6" data-id="element-1135">Transaction Progress</h3>

      <div className="space-y-4" data-id="element-1136">
        {steps.map((step, index) => <div key={step.id} className="flex items-start gap-4" data-id="element-1137">
            {/* Icon */}
            <div className="flex flex-col items-center" data-id="element-1138">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center border-2 ${step.status === 'completed' ? 'bg-green-50 border-green-500' : step.status === 'current' ? 'bg-blue-50 border-blue-500' : 'bg-gray-50 border-gray-300'}`} data-id="element-1139">
                {step.status === 'completed' ? <Check className="w-5 h-5 text-green-600" data-id="element-1140" /> : step.status === 'current' ? <Clock className="w-5 h-5 text-blue-600" data-id="element-1141" /> : <Circle className="w-5 h-5 text-gray-400" data-id="element-1142" />}
              </div>
              {index < steps.length - 1 && <div className={`w-0.5 h-12 ${step.status === 'completed' ? 'bg-green-500' : 'bg-gray-300'}`} data-id="element-1143"></div>}
            </div>

            {/* Content */}
            <div className="flex-1 pb-8" data-id="element-1144">
              <div className="flex items-center justify-between mb-1" data-id="element-1145">
                <h4 className={`font-bold text-sm ${step.status === 'completed' ? 'text-green-700' : step.status === 'current' ? 'text-blue-700' : 'text-gray-500'}`} data-id="element-1146">
                  {step.label}
                </h4>
                {step.date && <span className="text-xs text-gray-500 font-mono" data-id="element-1147">
                    {step.date}
                  </span>}
              </div>
              <p className="text-xs text-gray-600" data-id="element-1148">
                {step.status === 'completed' && 'Completed'}
                {step.status === 'current' && 'In Progress'}
                {step.status === 'pending' && 'Pending'}
              </p>
            </div>
          </div>)}
      </div>
    </div>;
}